import { FleekError } from './FleekError';

type TwoFactorSecretKeyFailedToDecryptErrorOptions = Record<string, never>;

export class TwoFactorSecretKeyFailedToDecryptError extends FleekError<TwoFactorSecretKeyFailedToDecryptErrorOptions> {
  public name = 'TwoFactorSecretKeyFailedToDecryptError';

  toString = () => 'Failed to decrypt 2FA secret key.';
}
